var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgReporting(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "-2 -4 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.4505 0.223877L15.6758 0.674554C15.8239 0.970649 15.7577 1.31786 15.536 1.53992L10.1641 9.06056L6.13154 6.03613L2.11713 11.0541L0.945827 10.1171L5.86846 3.96381L9.83588 6.93938L13.4817 1.83519L10.2446 2.01445C9.83101 2.03735 9.47717 1.72064 9.45427 1.30706C9.43137 0.893483 9.74808 0.539645 10.1617 0.516743L15.4505 0.223877ZM16.0453 2.99414C16.4122 2.80183 16.8655 2.94334 17.0578 3.31021L17.6955 4.52677C17.8878 4.89363 17.7463 5.34693 17.3795 5.53924C17.0126 5.73155 16.5593 5.59004 16.367 5.22318L15.7293 4.00662C15.537 3.63975 15.6785 3.18645 16.0453 2.99414ZM0.25 14C0.25 13.5858 0.585786 13.25 1 13.25H17C17.4142 13.25 17.75 13.5858 17.75 14C17.75 14.4142 17.4142 14.75 17 14.75H1C0.585786 14.75 0.25 14.4142 0.25 14Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReporting);
export default __webpack_public_path__ + "static/media/reporting.fe963f85.svg";
export { ForwardRef as ReactComponent };